module.exports = __webpack_public_path__ + "img/appDownload.4855c38a.png";